import React from 'react'
import { connect } from 'react-redux'

/**
 * HOC that Handles whether or not the user is allowed to do specific actions required by component.
 * @param {Array<String>} actions - Actions required by component.
 * @param {Array<String>} blacklistedRoles - user roles that are not allowed to access component.
 * @returns {Component}
 */
export default (roles) => {
  return (WrappedComponent) => {
    const ActionsWithAuthorization = (props) => {
      const {
        user: { role: userRole },
      } = props

      // not allowed, don't render anything
      if (!Object.keys(roles).includes(userRole)) return null

      // make a copy of props
      const newProps = Object.assign({}, props)
      newProps.capabilities = roles[userRole]

      // delete reducer props
      delete newProps.user
      delete newProps.dispatch

      // render the component with passed props
      return <WrappedComponent {...newProps} />
    }

    return connect((state) => {
      return { user: state.user }
    })(ActionsWithAuthorization)
  }
}
